module.exports = __webpack_public_path__ + "static/img/bg-tr.319c6d83.png";